import { listMentorshipOffers, listMentorshipSessions } from '@/services/academy/mentorships.service'

export default {
	namespaced: true,
	state: {
		offers:         { data: [], meta: { total: 0 } },
		offersStatus:   'init',
		sessions:       { data: [], meta: { total: 0 } },
		sessionsStatus: 'init',
	},
	getters: {
		getOffers:         (s) => s.offers,
		getOffersStatus:   (s) => s.offersStatus,
		getSessions:       (s) => s.sessions,
		getSessionsStatus: (s) => s.sessionsStatus,
	},
	mutations: {
		SET_OFFERS(state, v)          { state.offers = v },
		SET_OFFERS_STATUS(state, v)   { state.offersStatus = v },
		SET_SESSIONS(state, v)        { state.sessions = v },
		SET_SESSIONS_STATUS(state, v) { state.sessionsStatus = v },
	},
	actions: {
		async fetchOffers({ commit }, params) {
			commit('SET_OFFERS_STATUS', 'pending')
			try {
				const { data } = await listMentorshipOffers(params)
				commit('SET_OFFERS', data)
				commit('SET_OFFERS_STATUS', 'init')
			} catch {
				commit('SET_OFFERS_STATUS', 'error')
			}
		},
		async fetchSessions({ commit }, params) {
			commit('SET_SESSIONS_STATUS', 'pending')
			try {
				const { data } = await listMentorshipSessions(params)
				commit('SET_SESSIONS', data)
				commit('SET_SESSIONS_STATUS', 'init')
			} catch {
				commit('SET_SESSIONS_STATUS', 'error')
			}
		},
	},
}
